import React, { useState } from 'react';
import CustomCard from '../../../components/CustomCard';
import EditButton from '../../../components/button/EditButton';
import CustomerSummary from '../../customer/CustomerSummary';
import CustomerFormConfig from '../../customer/CustomerFormConfig';
import CustomerSection from '../checkout/CustomerSection';
import DivBetween from '../../../components/div/DivBetween';
import { Actions } from '../../../../client/Actions';

const ReservationCustomerSummary = ({
  reservation,
  setReservation,
  onReload,
}) => {
  const [editMode, setEditMode] = useState(false);
  const [formKey, setFormKey] = useState(Date.now());
  const [tmpCustomer, setTmpCustomer] = useState(reservation.customer);
  const [ready, setReady] = useState(false);

  const handleCustomerUpdate = (customer) => {
    setTmpCustomer(customer);
  };

  const handleSave = () => {
    Actions.post(
      `/reservation/${reservation.id}/customer`,
      tmpCustomer,
      (updatedReservation) => {
        setReservation(updatedReservation);
        setEditMode(false);
      },
    );
  };

  return (
    <>
      {editMode ? (
        <CustomerSection
          customer={tmpCustomer}
          setCustomer={handleCustomerUpdate}
          formKey={formKey}
          setNewCustomerReady={setReady}
          onCancel={() => {
            setTmpCustomer(reservation.customer);
            setEditMode(false);
          }}
          onSave={tmpCustomer.id !== reservation.customer.id && handleSave}
          withoutNew={true}
          setFormKey={setFormKey}
        />
      ) : (
        <CustomCard
          title={
            <DivBetween>
              Dane klienta
              <EditButton onClick={() => setEditMode(true)}>Edytuj</EditButton>
            </DivBetween>
          }
          shadow={false}
        >
          <CustomerSummary
            customer={reservation.customer}
            fields={CustomerFormConfig.fields}
          />
        </CustomCard>
      )}
    </>
  );
};

export default ReservationCustomerSummary;
